import moment from 'moment';

export default function($filter) {
  'ngInject';

  return (cycle_date, cycle, issue_date, offset = false, extension_date = false) => {
    let startDate = $filter('RangeDate')(moment(cycle_date), cycle, 1);

    if (issue_date && new Date(issue_date).getTime() > new Date(startDate).getTime()) {
      startDate = issue_date;
    }

    if (offset) {
      const tempStartDate = new Date(startDate);
      tempStartDate.setFullYear(tempStartDate.getFullYear() - offset);

      startDate = tempStartDate.toISOString();

      const tempCycleDate = new Date(cycle_date);
      tempCycleDate.setFullYear(tempCycleDate.getFullYear() - offset);

      cycle_date = tempCycleDate.toISOString();
    }

    return `${$filter('PrettyDate')(startDate)} - ${$filter('PrettyDate')(extension_date || cycle_date)}`;
  };
}



// WEBPACK FOOTER //
// ./src/app/filters/CycleDuration.js